import React from "react";
import { BoxLoading, Spinner } from "../../../../../../../components/loading";
import { NotifyContainer, SeenMarkContainer } from "./style";
import { formatDateTime1 } from "../../../../../../../lib/normalizeDate";

const Index = props => {
  const {
    data,
    loading,
    isSeen,
    readLoading,
    isAnnouncement,
    onClick,
    handleReadUnReadClick,
    handleRemove,
    removeLoading
  } = props;
  const { created_at, title, message, summary, externalLink } = data;
  const textMessage = isAnnouncement ? summary : message;

  return (
    <NotifyContainer
      onClick={() => {
        onClick();
      }}
      loadingBox={!!loading}
    >
      {loading && (
        <div className="loading-parent">
          <BoxLoading />
        </div>
      )}
      <div className="notify-content-container">
        <div className="top-row">
          <div className="right-part">
            <SeenMark
              isSeen={isSeen}
              seenLoading={readLoading}
              onClick={handleReadUnReadClick}
            />
            <div className="date">{formatDateTime1(created_at)}</div>
          </div>
          {externalLink && (
            <i className="is-link-card-icon icon mapsa-left-arrow-chevron" />
          )}
          {!isAnnouncement && (
            <React.Fragment>
              {removeLoading ? (
                <Spinner size="small" />
              ) : (
                <i
                  onClick={e => {
                    e.stopPropagation();
                    handleRemove();
                  }}
                  className="icon remove-icon mapsa-delete"
                />
              )}
            </React.Fragment>
          )}
        </div>
        <div className="title">{title}</div>
        <div className="footer">
          <div className="message">{textMessage}</div>
        </div>
      </div>
    </NotifyContainer>
  );
};

export default Index;

const SeenMark = ({ isSeen, seenLoading, onClick }) => {
  return (
    <SeenMarkContainer
      isSeen={isSeen}
      seenLoading={seenLoading}
      onClick={e => {
        e.stopPropagation();
        onClick(true);
      }}
    >
      <div className="seen-mark">{seenLoading && <Spinner size="small" />}</div>
    </SeenMarkContainer>
  );
};
